import {Item} from "../types";
import {AccessCodeAlphabet, Box, Occupancy} from "@variocube/app-api";

export interface ItemRemoval {
    item: Item;
    occupancy: Occupancy;
    box: Box;
}

export const ACCESS_CODE_SHAPE = {
    accessCodeShape: {
        length: 6,
        alphabet: AccessCodeAlphabet.OneToNine,
    }
};